import { render, staticRenderFns } from "./approvalDetails.vue?vue&type=template&id=6bc18b08&scoped=true&"
import script from "./approvalDetails.vue?vue&type=script&lang=js&"
export * from "./approvalDetails.vue?vue&type=script&lang=js&"
import style0 from "./approvalDetails.vue?vue&type=style&index=0&id=6bc18b08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bc18b08",
  null
  
)

export default component.exports